var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"d-flex align-center mb-12 back-button"},[_c('img',{attrs:{"src":"/img/back.svg","alt":"Back to previous step"}}),_c('span',{staticClass:"d-inline-flex ml-4"},[_vm._v("BACK")])])
}]

export { render, staticRenderFns }